<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}
.eye {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 20%;
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">老499活动订单列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="toShowUserValidFun()">
          用户验证：{{ onOffFlagName }}
        </button>
        <button class="common-bg-button" @click="toUpdatePileStatusFun()">
          激活切换
        </button>
        <button class="common-bg-button" @click="toEditOrder()">
          活动订单编辑
        </button>
        <button
          class="common-bg-button"
          @click="toOneDialog()"
          v-if="$S.checkUserMenu('refundAuditFir')"
        >
          退款审核（一审）
        </button>
        <button
          class="common-bg-button"
          @click="toTwoDialog()"
          v-if="$S.checkUserMenu('refundAuditSec')"
        >
          退款审核（二审）
        </button>
        <button class="common-bg-button" @click="toShowRtOrderEditFun()">
          线下退款
        </button>
        <button
          class="common-bg-button"
          @click="() => { showMultiQuerys = !showMultiQuerys }">
          高级筛选
        </button>
        <button class="common-bg-button" @click="toExportList()">导 出</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input
                clearable
                v-model="queryInfo.searchKey"
                size="small"
                placeholder="请输入订单编号/用户手机号/用户姓名"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select
                v-model="orderStatus"
                size="small"
                clearable
                multiple
                @change="orderStatusChange"
                class="full-width"
                placeholder="请选择订单状态"
              >
                <el-option
                  v-for="a in orderStatusList"
                  :key="a.code"
                  :label="a.title"
                  :value="a.code"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩激活状态</p>

              <el-select
                v-model="queryInfo.activateStatus"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择订单状态"
              >
                <el-option
                  v-for="a in activeStatusList"
                  :key="a.code"
                  :label="a.title"
                  :value="a.code"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.createFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span class="time-query-line">-</span>
                <el-date-picker
                  v-model="queryInfo.createToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩启用时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.periodFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span class="time-query-line">-</span>
                <el-date-picker
                  v-model="queryInfo.periodToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩到期时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.expireFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span class="time-query-line">-</span>
                <el-date-picker
                  v-model="queryInfo.expireToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">省市区</p>
              <!-- <Area
                :showLevel="3"
                :key="datekey"
                @updateSelAreas="updateSelAreas"
                :selProvince="queryInfo.province"
                :selCity="queryInfo.city"
                :selArea="queryInfo.area"
              /> -->
              <el-cascader
                  style="width:400px;"
                  size="small"
                  clearable
                  ref="cascader"
                  filterable
                  :options="options"
                  v-model="selectedOptions"
                  @change="handleChange"
              >
              </el-cascader>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款状态</p>
              <el-select
                  class="full-width"
                  size="small"
                  v-model="refundStatus"
                  clearable
                  multiple
                  @change="refundStatusChange"
                  placeholder="请选择"
              >
                <el-option label="申请退款（一审）" value="01"></el-option>
                <el-option label="申请退款（二审）" value="02"></el-option>
                <el-option label="退款完成" value="03"></el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款结果</p>
              <el-select
                  class="full-width"
                  size="small"
                  v-model="queryInfo.refundResult"
                  clearable
                  placeholder="请选择"
              >
                <el-option label="退款中" value="01"></el-option>
                <el-option label="退款成功" value="02"></el-option>
                <el-option label="退款失败" value="03"></el-option>
                <el-option label="线下退款" value="04"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">购买名称</p>
              <el-select v-model="queryInfo.packageId" size="small" clearable class="full-width" placeholder="请选择购买名称">
                <el-option label="499 订单" value="32101" />
                <el-option label="桩到家·7KW订阅版（含基础安装包）" value="32103" />
                <el-option label="桩到家·7KW订阅版（含30米安装包）" value="32104" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">分享状态</p>
              <el-select v-model="queryInfo.shareStatus" size="small" clearable class="full-width" placeholder="请选择购买名称">
                <el-option label="已分享" value="01" />
                <el-option label="未分享" value="02" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">分享类型</p>
              <el-select v-model="queryInfo.shareType" size="small" clearable class="full-width" placeholder="请选择购买名称">
                <el-option label="报名分享" value="01" />
                <el-option label="支付分享" value="02" />
                <el-option label="双重分享" value="03" />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">礼品领取状态</p>
              <el-select v-model="queryInfo.giftStatus" size="small" clearable class="full-width" placeholder="请选择购买名称">
                <el-option label="已领取" value="01" />
                <el-option label="未领取" value="02" />
              </el-select>
            </el-col>
          </el-row>
        </div>

        <div class="query-flex-btns-div margin-bottom-16">
          <button class="common-bg-button" @click="getListData(pagination, true)">
            搜 索
          </button>
          <button class="common-bg-button" @click="resetQuery()">重 置</button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" style="width: 100%" border stripe @selection-change="(sels) => { selections = sels }">
          <el-table-column type="selection" width="40" align="center" />
          <el-table-column prop="activityOrderNo" label="订单编号" width="240" align="center" fixed="left">
            <template slot-scope="scope">
              <span style="color: #409EFF; cursor: pointer;" @click="toOrderDetail(scope.row)">{{ scope.row.activityOrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="用户姓名" width="200" align="center" fixed="left" />
          <el-table-column prop="mobile" label="用户手机号" width="200" align="center" fixed="left" :key="Math.random()">
            <div slot="header">
              <span>用户手机号</span>
              <img
                style="width:20px;height:20px;"
                src="../../../assets/app-card-style/眼睛_隐藏.png"
                alt=""
                v-if="!isFlag"
                @click="flagChange()"
              />
              <img
                style="width:20px;height:20px;"
                src="../../../assets/app-card-style/眼睛_显示.png"
                alt=""
                v-if="isFlag"
                @click="flagChange()"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.mobile }}</span>
              <span v-else>{{
                scope.row.mobile
                  ? scope.row.mobile.replace(
                      scope.row.mobile.substring(2, 9),
                      "*******"
                    )
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatusName" label="订单状态" width="200" align="center" fixed="left">
            <template slot-scope="scope">
              <span style="color:#2871FF;" v-if="scope.row.orderStatus === '01'">已支付</span>
              <span style="color:#0BBAB4;" v-if="scope.row.orderStatus === '02'">使用中</span>
              <span style="color:#FF2828;" v-if="scope.row.orderStatus === '03'">已退款</span>
              <span style="color:#8D8D8D;" v-if="scope.row.orderStatus === '04'">已到期</span>
              <span style="color:#49AFE7;" v-if="scope.row.orderStatus === '05'">已报名</span>
              <span style="color:#E6A23C;" v-if="scope.row.orderStatus === '06'">换桩中</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderName" label="购买名称" width="200" align="center" />
          <el-table-column prop="province" label="省" width="200" align="center" />
          <el-table-column prop="city" label="市" width="200" align="center" />
          <el-table-column prop="area" label="区" width="200" align="center" />
          <el-table-column prop="address" label="详细地址" width="200" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="200" trigger="hover" :disabled="scope.row.address.length <= 10">
                <div>{{ scope.row.address }}</div>
                <span slot="reference" v-if="scope.row.address.length <= 10">{{scope.row.address}}</span>
                <span slot="reference" v-if="scope.row.address.length > 10">{{scope.row.address.substr(0, 10) + "..."}}</span>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column prop="vehicleModel" label="车辆型号" width="200" align="center" />
          <el-table-column prop="shareStatus" label="分享状态" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.shareStatus === '01'">{{ '已分享' }}</span>
              <span v-else-if="scope.row.shareStatus === '02'">{{ '未分享' }}</span>
              <span v-else>{{ '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shareType" label="分享类型" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.shareType === '01'">{{ '报名分享' }}</span>
              <span v-else-if="scope.row.shareType === '02'">{{ '支付分享' }}</span>
              <span v-else-if="scope.row.shareType === '03'">{{ '双重分享' }}</span>
              <span v-else>{{ '' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="giftStatus" label="礼品领取状态" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.giftStatus === '01'">{{ '已领取' }}</span>
              <span v-else-if="scope.row.giftStatus === '02'">{{ '未领取' }}</span>
              <span v-else>{{ '' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="activateStatusName" label="充电桩激活状态" width="200" align="center">
            <template slot-scope="scope">
              {{ scope.row.orderStatus == "03" ? "--" : scope.row.activateStatusName }}
            </template>
          </el-table-column>
          <el-table-column prop="pileCode" label="充电桩编码" width="200" align="center" />
          <el-table-column prop="payTransactionNo" label="关联支付流水号" width="240" align="center" />
          <el-table-column prop="refundStatusName" label="退款状态" width="240" align="center" />
          <el-table-column prop="refundResultName" label="退款结果" width="240" align="center" />
          <el-table-column prop="refundTransactionNo" label="退款流水号" width="240" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="300" trigger="hover" :disabled="scope.row.refundTransactionNo.length <= 30">
                <div>{{ scope.row.refundTransactionNo }}</div>
                <span slot="reference" v-if="scope.row.refundTransactionNo.length <= 30">
                  {{ scope.row.refundTransactionNo }}
                </span>
                <span slot="reference" v-if="scope.row.refundTransactionNo.length > 30">
                  {{scope.row.refundTransactionNo.substr(0, 10) + "..."}}
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="renewalCount" label="续约次数" width="200" align="center" />
          <el-table-column prop="bindTime" label="充电桩绑定时间" width="200" align="center" />
          <el-table-column prop="periodStartTime" label="充电桩启用时间" width="200" align="center" />
          <el-table-column prop="periodEndTime" label="充电桩到期时间" width="200" align="center" />
          <el-table-column prop="createdWhen" label="订单创建时间" width="200" align="center" />
          <el-table-column prop="remark" label="订单备注" width="200" align="center">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="300" trigger="hover" :disabled="scope.row.remark.length <= 30">
                <div>{{ scope.row.remark }}</div>
                <span slot="reference" v-if="scope.row.remark.length <= 30">
                  {{scope.row.remark }}
                </span>
                <span slot="reference" v-if="scope.row.remark.length > 30">
                  {{ scope.row.remark.substr(0, 10) + "..."}}
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="activateOperatePer" label="激活切换操作人" width="200" align="center" />
          <el-table-column prop="activateOperateWhen" label="激活切换操作时间" width="200" align="center" />
          <el-table-column prop="refundOperatePer" label="退款操作人" width="200" align="center" />
          <el-table-column prop="refundOperateWhen" label="退款操作时间" width="200" align="center" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>

    <!-- 单用户验证开关 -->
    <el-dialog
      title="单用户验证开关"
      width="520px"
      :visible.sync="showSignUserValidDialog"
    >
      <el-form
        :model="userValidFormInfo"
        ref="userValidForm"
        :rules="userValidFormRules"
      >
        <div class="notice-main-title-div">同一个手机号仅申请一次</div>
        <div class="notice-radio-div">
          <el-radio-group v-model="setOnOffFlag">
            <el-radio label="Y">开启</el-radio>
            <el-radio label="N">关闭</el-radio>
          </el-radio-group>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitUserValidForm('userValidForm')"
          size="small"
          >提 交</el-button
        >
        <el-button @click="showSignUserValidDialog = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 退款编辑 -->
    <el-dialog title="退款编辑" width="520px" :visible.sync="showRtOrderDialog">
      <el-form
        :model="rtOrderFormInfo"
        ref="userRfForm"
        :rules="rtOrderFormRules"
      >
        <el-form-item label="退款流水号" prop="transactionNo">
          <el-input
            clearable
            v-model="rtOrderFormInfo.transactionNo"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitRtOrderForm('userRfForm')"
          size="small"
          >提 交</el-button
        >
        <el-button @click="showRtOrderDialog = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 退款审核（一审） -->
    <el-dialog :title="title" width="40%" :visible.sync="showOneDialog">
      <el-form :model="oneFormInfo" ref="oneFormInfo" :rules="oneFormRules">
        <el-form-item label="审核记录">
          <el-table
            :data="oneTableData"
            height="250"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="operationTypeName"
              label="操作"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="createdByName"
              label="审核人"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="auditStatusName"
              label="审核结果"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="auditReason"
              label="不通过原因"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="createdWhen" label="操作时间" align="center">
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="退款备注">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="oneFormInfo.refundRemark"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <el-form-item label="退款原因">
          <el-input
            clearable
            v-model="oneFormInfo.refundReason"
            size="small"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-input
            clearable
            v-model="oneFormInfo.refundWhen"
            size="small"
            disabled
          ></el-input>
        </el-form-item>
        <div style="display:flex;">
          <el-form-item :label="oneTitle" prop="auditStatus">
            <el-radio-group
              v-model="oneFormInfo.auditStatus"
              @change="oneChange"
            >
              <el-radio label="01">审核通过</el-radio>
              <el-radio label="02">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item
            label="二审"
            :prop="twoDisabled ? '' : 'auditStatus'"
            style="margin-left:40px;"
          >
            <el-radio-group
              v-model="oneFormInfo.auditStatus"
              :disabled="twoDisabled"
              @change="twoChange"
            >
              <el-radio label="01">审核通过</el-radio>
              <el-radio label="02">审核不通过</el-radio>
            </el-radio-group>
          </el-form-item> -->
        </div>
        <div style="display:flex;">
          <el-form-item label="原因" v-if="oneIsFlag" prop="auditReason">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="oneFormInfo.auditReason"
              maxlength="30"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <!-- <el-form-item
            label="原因"
            v-if="twoIsFlag"
            prop="auditReason"
            style="margin-left:40px;"
          >
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="oneFormInfo.auditReason"
            maxlength="30"
            show-word-limit
          >
          </el-input>
          </el-form-item> -->
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
        :disabled="subDisabled"
          type="primary"
          @click="submitOneForm('oneFormInfo')"
          size="small"
          >提 交</el-button
        >
        <el-button @click="showOneDialog = false" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import Area from "../../../components/area-select/index.vue";
import {
  codeToText,
  regionData,
  TextToCode,
  pcaTextArr,
} from "element-china-area-data"; //导入地图数据
export default {
  components: {
    Area,
  },
  data() {
    return {
      subDisabled:false,
      orderStatus:[],
      refundStatus:[],
      oneIsFlag: false,
      oneTitle: "一审",
      twoIsFlag: false,
      oneDisabled: false,
      twoDisabled: false,
      title: "退款审核（一审）",
      showOneDialog: false,
      oneTableData: [],
      selectedOptions: [],
      options: pcaTextArr,
      datekey: Date.now(),
      isFlag: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      paidTime: [],
      showMultiQuerys: false,
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      showSignUserValidDialog: false,
      userValidFormInfo: {},
      userValidFormRules: {},
      showRtOrderDialog: false,
      rtOrderFormInfo: {},
      rtOrderFormRules: {
        transactionNo: [
          { required: true, message: "请输入退款流水号", trigger: "blur" },
        ],
      },
      oneFormInfo: {
        auditStatus: "01",
      },
      oneFormRules: {
        auditStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],

        auditReason: [
          { required: true, message: "请输入不通过原因", trigger: "blur" },
        ],
      },
      onOffFlag: "",
      setOnOffFlag: "",
      onOffFlagName: "",
      orderStatusList: [
        // 01已支付,02使用中,03已退款,04已到期,05已报名,06换桩中(售后换桩专用)
        { code: "01", title: "已支付" },
        { code: "02", title: "使用中" },
        { code: "03", title: "已退款" },
        { code: "04", title: "已到期" },
        { code: "05", title: "已报名" },
        { code: "06", title: "换桩中" },
      ],
      activeStatusList: [
        // 01已激活，02激活中，03已失效，04激活异常
        { code: "01", title: "已激活" },
        { code: "02", title: "激活中" },
        { code: "03", title: "已失效" },
        { code: "04", title: "激活异常" },
      ],
    };
  },
  methods: {
    orderStatusChange(val){
      this.queryInfo.orderStatus = val.join(',')
    },
    refundStatusChange(val){
      this.queryInfo.refundStatus = val.join(',')
    },
    oneChange(val) {
      this.oneIsFlag = val === "02";
    },
    twoChange(val) {
      if (val == "02") {
        this.twoIsFlag = true;
      } else {
        this.twoIsFlag = false;
      }
    },
    toOneDialog() {
      if (this.checkSelectOne(this.selections)) {
        if(!this.selections[0].activityOrderNo){
        return this.$U.error("当前订单状态不能申请退款");
      }
      if(this.selections[0].refundStatus != '01' ||this.selections[0].refundStatus == '03'){
        // return this.$U.error("非此审核阶段");
        this.subDisabled = true
      }else{
        this.subDisabled = false
      }
        this.$nextTick(() => {
          this.$refs.oneFormInfo.resetFields();
        });

        this.oneFormInfo = this.selections[0];
        this.showOneDialog = true;
        this.title = "退款审核（一审）";
        (this.oneTitle = "一审"), (this.oneFormInfo.operationType = "01");
        this.$set(this.oneFormInfo, "auditStatus", "01");

        this.oneIsFlag = false;

        this.getRecordPage();
      }
    },
    toTwoDialog() {
      if (this.checkSelectOne(this.selections)) {
      if(!this.selections[0].activityOrderNo){
        return this.$U.error("当前订单状态不能申请退款");
      }
      if(this.selections[0].refundStatus != '02'||this.selections[0].refundStatus == '03'){
        // return this.$U.error("非此审核阶段");
        this.subDisabled = true
      }else{
        this.subDisabled = false
      }
        this.$nextTick(() => {
          this.$refs.oneFormInfo.resetFields();
        });
        this.oneFormInfo = this.selections[0];
        this.showOneDialog = true;
        this.title = "退款审核（二审）";
        (this.oneTitle = "二审"), (this.oneFormInfo.operationType = "02");
        this.$set(this.oneFormInfo, "auditStatus", "01");

        this.oneIsFlag = false;
        this.getRecordPage();
      }
    },
    handleChange(e) {
      let province = this.selectedOptions[0]; //省
      let city = this.selectedOptions[1]; //市
      let county = this.selectedOptions[2]; //区(三级联动带区的话可以加上这个，二级联动不需要这个)
      // if (city == "市辖区") {
      //   //选择北京市的话，第二个选项为输入框
      //   city = province; //这里根据后台需求，给它赋值，我这里是如果为市辖区，城市和省名字保持一致
      // }
      //这里是请求赋值
      this.queryInfo.province = province;
      this.queryInfo.city = city;
      this.queryInfo.area = county; //三级联动带区可以加上，二级联动(省市)不需要
      console.log(this.formInfo);
    },
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    updateSelAreas(val) {
      this.queryInfo.province = val.province;
      this.queryInfo.city = val.city;
      this.queryInfo.area = val.area;
    },
    //获取数据
    init() {
      this.getListData(this.pagination, true);
      this.getMobileValidStatus();
    },
    // 查询用户验证状态
    getMobileValidStatus() {
      let _ = this;
      _.$H.post(_, _.$A.activityOrder.checkMobileQuery, {}).then((res) => {
        console.log(res);
        this.onOffFlag = res.data.data.onOff || "N";
        this.setOnOffFlag = res.data.data.onOff || "N";
        this.onOffFlagName = "Y" == this.onOffFlag ? "开启" : "关闭";
      });
    },
    // 查询用户验证状态
    getRecordPage() {
      let _ = this;

      let obj = {
        corpNo: _.selections[0].corpNo,
        activityOrderNo: _.selections[0].activityOrderNo,
      };

      _.$H.post(_, _.$A.activityOrder.findAuditRecordPage, obj).then((res) => {
        console.log(res);
        _.oneTableData = res.data.data.content || [];
      });
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.queryInfo.orderStatus = _.queryInfo.orderStatus?_.queryInfo.orderStatus.join(','):[]
      // _.queryInfo.refundStatus = _.queryInfo.refundStatus?_.queryInfo.refundStatus.join(','): []
      _.$H.post(_, _.$A.activityOrder.list, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    // 点击订单编号跳转详情页
    toOrderDetail(row) {
      this.$router.push({
        name: "activityOrderDetail",
        query: {
          orderId: row.activityOrderId,
        },
      });
    },
    // 活动订单编辑
    toEditOrder() {
      if (this.checkSelectOne(this.selections)) {
        const editInfo = this.selections[0];
        this.$router.push({
          name: "activityOrderDetail",
          query: {
            orderId: editInfo.activityOrderId,
          },
        });
      }
    },
    //选择时间
    pickdate(time) {
      let _ = this;
      // 拆分时间区间
      _.queryInfo.fromTransactionSucceedTime = time ? time[0] : "";
      _.queryInfo.toTransactionSucceedTime = time ? time[1] : "";
    },
    //重置
    reset() {
      delete this.queryInfo.walletListNo;
      delete this.queryInfo.mobile;
      delete this.queryInfo.packagName;
      delete this.queryInfo.fromTransactionSucceedTime;
      delete this.queryInfo.toTransactionSucceedTime;
      this.paidTime = [];
      this.getListData(this.pagination, true);
    },
    toShowUserValidFun() {
      this.showSignUserValidDialog = true;
    },
    submitUserValidForm() {
      let _ = this;
      _.$H
        .post(_, _.$A.activityOrder.setOnOff, { onOff: this.setOnOffFlag })
        .then(() => {
          _.showSignUserValidDialog = false;
          _.getMobileValidStatus();
          _.$U.success("保存成功");
          _.$U.hideLoading(_);
        });
    },
    // 退款编辑
    toShowRtOrderEditFun() {
      if (this.checkSelectOne(this.selections)) {
        // if(this.selections[0].refundResult == ''|| this.selections[0].refundResult == '01' || this.selections[0].refundResult == '02'){
        //  return this.$U.error("当前状态无法操作");
        // }
        if(this.selections[0].refundResult != '03'){
         return this.$U.error("当前状态无法操作");
        }
        this.rtOrderFormInfo = this.selections[0];
        this.showRtOrderDialog = true;
      }
    },
    // 桩激活切换
    toUpdatePileStatusFun() {
      let _ = this;
      if (this.checkSelectOne(this.selections)) {
        const editInfo = this.selections[0];
        const submitInfo = {
          activateStatusBef: editInfo.activateStatus,
          pileCode: editInfo.pileCode,
          corpNo: editInfo.corpNo,
          activityOrderNo: editInfo.activityOrderNo,
        };
        _.$H
          .post(_, _.$A.activityOrder.activateExchange, submitInfo)
          .then(() => {
            _.$U.hideLoading(_);
            _.$U.success("提交成功！");
            _.getListData(_.pagination, true);
          });
      }
    },
    // 退款提交
    submitRtOrderForm(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);
          _.$H
            .post(_, _.$A.activityOrder.refundEdit, _.rtOrderFormInfo)
            .then(() => {
              _.$U.hideLoading(_);
              _.$U.success("修改成功！");
              _.showRtOrderDialog = false;
              _.getListData(_.pagination, true);
            });
        }
      });
    },
    // 退款提交
    submitOneForm(formName) {
      let _ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$U.showLoading(_);

          (_.oneFormInfo.corpNo = _.selections[0].corpNo),
            (_.oneFormInfo.activityOrderNo = _.selections[0].activityOrderNo),
            _.$H
              .post(_, _.$A.activityOrder.refundAudit, _.oneFormInfo)
              .then(() => {
                _.$U.hideLoading(_);
                _.$U.success("修改成功！");
                _.showOneDialog = false;
                _.getListData(_.pagination, true);
              });
        }
      });
    },
    // 导出
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.activityOrder.export, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = "http://192.168.8.174:7997" + res.data.data.filePath;
        var downUrl ="http://ocharge.shzhida.com:6777" + res.data.data.filePath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    resetQuery() {
      this.queryInfo = {
        searchKey: undefined,
        orderStatus: undefined,
        refundStatus: undefined,
        refundResult: undefined,
        activateStatus: undefined,
        createFromTime: undefined,
        createToTime: undefined,
        periodFromTime: undefined,
        periodToTime: undefined,
        expireFromTime: undefined,
        expireToTime: undefined,
        province: undefined,
        city: undefined,
        area: undefined,
      };
      this.selectedOptions = []
      this.refundStatus = []
      this.orderStatus = []
      this.datekey = Date.now();

      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
